export const ALL = 'All';

export const RISK = "RISK";
export const RETURN = "RETURN";

// 거래량 최고, 수익률 최고, 시총 최고
export const THEME_KEYS = ["maxVolume", "maxReturn", "maxMarketCap"] as const

export const INDUSTRY_AVG = '산업 평균';

export const DETAIL_AVG_COMPARISON_N = 3;


export const HIGH = '높음';
export const HIGH_ENG = 'Higher';
export const SIMILAR = '비슷';
export const SIMILAR_ENG = 'Similar';
export const LOW = '낮음';
export const LOW_ENG = 'Lower';

export const RISK_KR = "리스크";
export const PRICE_KR = "가격";
export const CHART_KR = "차트";


export const LEVEL_CHANGE = '등급 변동';
export const MONTHLY_PER = '1개월 평균';
export const INDUSTRY_PER = '산업 평균';
export const RANGE = '변동폭';
export const OVER = '이탈';
export const PRICE_FORECAST = '가격 전망';
export const SHORT_TERM = '단기변동신호';

export const DETAIL_AUTO_SCROLL = 176;

export const MONTH_ENG = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
]
export const AI_EMAILS = ['admin_O', 'admin_X', 'admin_A', 'admin_B', 'admin_C', 'admin_D', 'admin_E']
